<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport
      [attr.role]="'dialog'"
      [mode]="'over'"
      [opened]="false">
    <mat-toolbar class="menu-title">{{ 'nav.menu' | translate }}</mat-toolbar>
    <mat-nav-list class="nav-list">
      <a mat-list-item class="menu-links" (click)="navFunction('/')">{{ 'nav.pagine.home' | translate }}</a>
      <a mat-list-item class="menu-links" (click)="navFunction('/home/aree')">{{ 'nav.pagine.map' | translate }}</a>
      <a mat-list-item class="menu-links" (click)="navFunction('/home/poi')">{{ 'nav.pagine.poi' | translate }}</a>
      <a mat-list-item class="menu-links" (click)="navFunction('/home/itinerari')">{{ 'nav.pagine.itin' | translate }}</a>
      <a mat-list-item class="menu-links" (click)="navFunction('/home/about')">{{ 'nav.pagine.about' | translate }}</a>
      <a mat-list-item class="menu-links" *ngIf="isLoggedIn; else areaRiservata" (click)="logInOrLogOut()">{{ 'nav.pagine.logout' | translate }}</a>
      <ng-template #areaRiservata>
        <a mat-list-item class="menu-links" (click)="logInOrLogOut()">{{ 'nav.pagine.login' | translate }}</a>
      </ng-template>
    </mat-nav-list>
    <mat-toolbar *ngIf="isLoggedIn" class="menu-title">{{ 'nav.admin' | translate }}</mat-toolbar>
    <mat-nav-list *ngIf="isLoggedIn" class="nav-list">
      <a mat-list-item class="menu-links" *ngIf="superadmin || admin || editor" (click)="navFunction('/lista-poi')">{{ 'nav.gestione.poi' | translate }}</a>
      <a mat-list-item class="menu-links" *ngIf="superadmin || admin || editor" (click)="navFunction('/lista-itinerari')">{{ 'nav.gestione.itin' | translate }}</a>
      <a mat-list-item class="menu-links" *ngIf="superadmin" (click)="navFunction('/lista-percorsi-tematici')">{{ 'nav.gestione.theme' | translate }}</a>
      <a mat-list-item class="menu-links" *ngIf="superadmin || admin" (click)="navFunction('/lista-da-approvare')">{{ 'nav.gestione.approve' | translate }}</a>
      <a mat-list-item class="menu-links" *ngIf="superadmin || admin" (click)="navFunction('/lista-utenti')">{{ 'nav.gestione.utenti' | translate }}</a>
      <a mat-list-item class="menu-links" *ngIf="superadmin || admin || editor" (click)="navFunction('/cambio-password')">{{ 'nav.gestione.pwd' | translate }}</a>
    </mat-nav-list>
    <div class="language-choice">
      <img src="../../assets/navbar/flag_italia.png" title="Italiano" (click)="changeLanguage('it')">
      <img src="../../assets/navbar/flag_slovenia.png" title="Slovenščina" (click)="changeLanguage('sl')">
      <img src="../../assets/navbar/flag_england.png" title="English" (click)="changeLanguage('en')">
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar>
      <mat-toolbar-row class="toolbar-lang-row">
        <div class="lang-bar">
          <div class="toolbar-language-choice with-shadow">
            <span>{{ 'nav.change_lang' | translate }}</span>
            <img src="../../assets/navbar/flag_italia.png" title="Italiano" (click)="changeLanguage('it')">
            <img src="../../assets/navbar/flag_slovenia.png" title="Slovenščina" (click)="changeLanguage('sl')">
            <img src="../../assets/navbar/flag_england.png" title="English" (click)="changeLanguage('en')">
          </div>
          <div class="toolbar-language-choice">
            <span>{{ 'nav.follow' | translate }}</span>
            <a href="https://www.facebook.com/primisproject">
              <img src="../../assets/navbar/facebook_logo_new.png" title="Facebook">
            </a>
            <a href="https://twitter.com/primisproject">
              <img src="../../assets/navbar/twitter-x.svg" title="Twitter">
            </a>
            <a href="https://www.instagram.com/primisplusproject/">
              <img src="../../assets/navbar/instagram_logo_new.png" title="Instagram">
            </a>
          </div>
        </div>
      </mat-toolbar-row>
      <mat-toolbar-row [ngClass]="{'h-220': !isHome, 'h-400': isHome}" class="toolbar-row">
        <div class="over-top-bar">
          <div class="over-top-bar-above">
            <div class="header-site-primis-img clickable">
              <img src="../../assets/about/logo_primis.svg" (click)="redirectToPrimis()">
            </div>
            <div [ngClass]="{'hide': isHome}" class="header-site-name">
              <a (click)="navFunction('/')">
                <h2>Primis & Primis Plus</h2>
                <p>{{ 'nav.title.primis' | translate }}</p>
              </a>
            </div>
            <div class="header-site-primis-plus-img clickable">
              <img src="../../assets/about/logo_primis_plus.jpg" (click)="redirectToPrimisPlus()">
            </div>
          </div>
          <div *ngIf="isHome" class="over-top-bar-below">
            <h2>Primis & Primis Plus</h2>
            <h6>{{ 'nav.title.primis' | translate }}</h6>
          </div>
        </div>
      </mat-toolbar-row>
      <mat-toolbar-row class="top-bar-desktop" id="top-bar-desktop">
        <div class="menu-btn">
          <button
            id="side-bar-btn"
            type="button"
            aria-label="Toggle sidenav"
            mat-icon-button
            (click)="drawer.toggle()">
            <mat-icon class="toggle-menu-icon" aria-label="Side nav toggle icon">menu</mat-icon>
          </button>
        </div>
        <div class="topbar-menu-links">
          <a (click)="navFunction('/home/about')">{{ 'nav.pagine.about' | translate }}</a>
          <a (click)="navFunction('/home/aree')">{{ 'nav.pagine.map' | translate }}</a>
          <a (click)="navFunction('/home/poi')">{{ 'nav.pagine.poi' | translate }}</a>
          <a (click)="navFunction('/home/itinerari')">{{ 'nav.pagine.itin' | translate }}</a>
        </div>
      </mat-toolbar-row>
      <mat-toolbar-row class="top-bar sticky">
        <div>
          <button
            id="side-bar-btn"
            type="button"
            aria-label="Toggle sidenav"
            mat-icon-button
            (click)="drawer.toggle()">
            <mat-icon class="toggle-menu-icon" aria-label="Side nav toggle icon">menu</mat-icon>
          </button>
          <span [title]="'nav.title.primis' | translate">
            <a class="site-name" (click)="navFunction('/')">
              PRIMIS
            </a>
          </span>
        </div>
        <div>
          <span>
            <a href="https://www.facebook.com/primisproject">
              <img src="../../assets/navbar/facebook_logo_new.png" alt="Facebook" class="logo" title="Facebook">
            </a>
          </span>
          <span>
            <a href="https://twitter.com/primisproject">
              <img src="../../assets/navbar/twitter-x.svg" alt="Twitter" class="logo" title="Twitter">
            </a>
          </span>
          <span>
            <a href="https://www.instagram.com/primisplusproject/">
              <img src="../../assets/navbar/instagram_logo_new.png" alt="Instagram" class="logo" title="Instagram">
            </a>
          </span>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>

    <!-- Add Content Here -->
    <ng-content class="ng-content-cont"></ng-content>

  </mat-sidenav-content>
</mat-sidenav-container>

